import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import './styles/base.css'
import './styles/app.css'

const container = document.getElementById('root')
if (!container) throw new Error('Falta el contenedor #root')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// El Service Worker se registra fuera del camino crítico: registrarlo antes de
// pintar retrasaría el primer frame sin dar nada a cambio en la primera visita.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void registerServiceWorker()
  })
}

async function registerServiceWorker() {
  const { registerSW } = await import('virtual:pwa-register')

  registerSW({
    immediate: false,
    onNeedRefresh() {
      // Nunca se recarga sola: el comensal puede tener el carrito a medio armar
      // y perderlo sin entender por qué. Se le ofrece y decide él.
      showUpdatePrompt()
    },
  })
}

function showUpdatePrompt() {
  const toast = document.createElement('div')
  toast.className = 'toast'
  toast.setAttribute('role', 'status')
  toast.innerHTML = '<span>Hay una carta actualizada.</span>'

  const button = document.createElement('button')
  button.className = 'chip'
  button.textContent = 'Actualizar'
  button.onclick = () => window.location.reload()

  const dismiss = document.createElement('button')
  dismiss.className = 'chip'
  dismiss.textContent = 'Ahora no'
  dismiss.onclick = () => toast.remove()

  toast.append(button, dismiss)
  document.body.append(toast)
}
